document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("sortToggle");
  const dropdown = document.getElementById("sortDropdown");
  const applyButton = document.getElementById("applySort");

  if (toggle && dropdown) {
    // Toggle dropdown visibility
    toggle.addEventListener("click", function () {
      dropdown.classList.toggle("visible");
    });
  }

  if (applyButton) {
    // Handle apply button click
    applyButton.addEventListener("click", function () {
      const selectedOption = document.querySelector(
        'input[name="customSort"]:checked'
      );
      if (selectedOption) {
        const sortValue = selectedOption.value;
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortValue);
        window.location.href = url.toString();
      }
    });
  }

  if (dropdown && toggle) {
    // Optional: close dropdown if clicked outside
    document.addEventListener("click", function (event) {
      if (!dropdown.contains(event.target) && !toggle.contains(event.target)) {
        dropdown.classList.remove("visible");
      }
    });
  }
});

$(document).ready(function () {
  // Function to update the URL with selected filters and reload
  function reloadWithFilters() {
    let params = new URLSearchParams();

    // Add all checked filters to params
    $('#filter-form input[type="checkbox"]:checked').each(function () {
      let name = $(this).attr("name");
      let value = $(this).val();
      params.append(name, value);
    });

    // Reload page with updated query string
    const newUrl =
      window.location.pathname +
      (params.toString() ? "?" + params.toString() : "");
    window.location.href = newUrl;
  }

  // Function to toggle clear button visibility
  function toggleClearButton() {
    if ($('#filter-form input[type="checkbox"]:checked').length > 0) {
      $(".clear-filters").show();
    } else {
      //$(".clear-filters").hide();
    }
  }

  // On page load: re-check checkboxes from URL params
  const urlParams = new URLSearchParams(window.location.search);
  $('#filter-form input[type="checkbox"]').each(function () {
    const name = $(this).attr("name");
    const value = $(this).val();
    if (urlParams.getAll(name).includes(value)) {
      $(this).prop("checked", true);
    }
  });

  toggleClearButton();

  // When any checkbox changes, reload page with updated filters
  $('#filter-form input[type="checkbox"]').on("change", function () {
    toggleClearButton();
    reloadWithFilters();
  });

  // Clear button clears all filters and reloads without query params
  $(".clear-filters").on("click", function () {
    // Uncheck all checkboxes
    $('#filter-form input[type="checkbox"]').prop("checked", false);
    // Hide clear button
    $(this).hide();
    // Reload page without any filters
    window.location.href = window.location.pathname;
  });
});

$(document).ready(function () {
  // Close all dropdowns
  function closeAllDropdowns() {
    $(".filter-content").slideUp(200);
    $(".filter-trigger").removeClass("open");
  }

  // Toggle dropdown on trigger click
  $(".filter-trigger").on("click", function (e) {
    e.stopPropagation();
    const $trigger = $(this);
    const $content = $trigger.next(".filter-content");
    const isOpen = $trigger.hasClass("open");

    if (isOpen) {
      $content.slideUp(200);
      $trigger.removeClass("open");
    } else {
      closeAllDropdowns();
      $content.slideDown(200);
      $trigger.addClass("open");
    }
  });

  // Close dropdowns when clicking outside
  $(document).on("click", function () {
    closeAllDropdowns();
  });
});
